export const UserReducer = (prevState = { }, action) => {
  let { type, payload } = action
  switch (type) {
    case 'set_profile':
      let newstate = { ...prevState, ...payload }
      return newstate
    default:
      return prevState
  }
}